import initializeCarousel from '../carousel';
import matchElementHeights from '../util/matchElementHeights';

export default {
  init() {
    // reviews carousel go!
    initializeCarousel();

    // set review item heights to match
    matchElementHeights('.review-item-text-wrapper');
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/reviews.js